<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.withTime = $event.withTime'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_groups') }}
                .form__field-body
                    cs-multiselect(
                        :options="groups"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.selectedGroups"
                        :disabled="groups.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="groups"
                        class="multiple-multiselect"
                        @select="checkLetters($event)"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWords') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.amountOfWords",
                        :max="15",
                        :min="3",
                        @increase="params.amountOfWords++",
                        @decrease="params.amountOfWords--",
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            .form__field.form__field--column
                label.form__label.form__label--left
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfLetters') }}
                .form__field-body.form__field-body--bold.form__field-body--inline
                    template(v-for='number in 10', v-if="number >= 3")
                        cs-checkbox.numbers-checkbox(
                            :checked='params.letters && !!params.letters[number - 3]',
                            :disabled="number <= getMinimalLength"
                            @change="setNumber(number, 'letters')"
                        )
                            span.numbers-checkbox__text {{ number }}
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="params.selectedGroups.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedGroups.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedGroups.length < 1")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import AnagramsApi from "../../../api/games/anagrams";
    import WordFieldApi from '../../../api/games/wordsField'

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_anagramsWithoutTime'),
                        withTime: false
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_anagramsWithTime'),
                        withTime: true
                    }
                ],
                letters: IntervalConfig.numbersForAnagrams,
                seconds: IntervalConfig.secondsForMemoryGames,
                selectedGameType: null,
                groups: [],
                groupsLength: [],
                params: null,
            }
        },
        mounted() {
            this.getGroups();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        updated () {
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        methods: {
            getGroups() {
                AnagramsApi.getGroups(this.user.locale).then(data => {
                    this.groups = Object.keys(data).map(key => data[key].group);
                    this.groupsLength = new Map(Object.keys(data).map(key => [data[key].group, data[key].length]));
                })
            },
            setNumber(number, type) {
                let array;
                let newObj;
                if (type === 'letters') {
                    array = this.params.letters.includes(number) ?
                            this.letters.slice(2, number - 1) :this.letters.slice(2, number);
                    newObj = {
                        letters: array
                    }
                }
                this.params = Object.assign(this.params, newObj);
            },
            checkLetters(event) {
                let number = this.groupsLength.get(event);
                if (!this.params.letters.includes(number)) {
                    this.setNumber(number, "letters");
                }
            },
            secondsLabel (second) {
                return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            getMinimalLength () {
                if(this.groupsLength.size) {
                    let lengths = [];
                    this.params.selectedGroups.forEach(key => {
                        lengths.push(this.groupsLength.get(key));
                    })
                    let minLength = lengths.sort()[0];
                    this.params.selectedGroups.forEach(key => {
                        minLength === this.groupsLength.get(key) && this.checkLetters(key);
                    })
                    return minLength;
                }
            }
        },
        watch: {
            'params.withTime': {
                handler (val) {
                    !this.params.showTime && val && (this.params.showTime = this.seconds[0]);
                    !val && (this.params.showTime = null);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
        font-weight: 500;
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .numbers-checkbox {
        margin-right: 15px;
        @include media($md) {
            &:not(:last-child) {
                margin-right: 15px;
            }
        }
    }

    .numbers-checkbox__text {
        min-width: 1.2rem;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

